import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DesignSystemComponentsModule } from '@montebravo.tech/design-system-components';
import { MbIconModule } from '../mb-icon/mb-icon.module';
import { HeaderAndMenuComponent } from './header-and-menu.component';

@NgModule({
    declarations: [HeaderAndMenuComponent],
    imports: [
        CommonModule,
        MatToolbarModule,
        MatIconModule,
        MatButtonModule,
        MatDividerModule,
        MatMenuModule,
        MatTooltipModule,
        FlexLayoutModule,
        MbIconModule,
        DesignSystemComponentsModule,
    ],
    exports: [HeaderAndMenuComponent],
})
export class HeaderAndMenuModule {}
